(function initChascaTestimonials() {
  const root = document.querySelector('[data-chasca-testimonials]');
  if (!root) return;

  const track = root.querySelector('[data-testimonials-track]');
  const prev = root.querySelector('[data-testimonials-prev]');
  const next = root.querySelector('[data-testimonials-next]');
  if (!track) return;

  function step() {
    const slide = track.querySelector('.chasca-testimonials__slide');
    if (!slide) return track.clientWidth * 0.85;
    const styles = window.getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 20;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateArrows() {
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll - 2;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd || maxScroll <= 0;
  }

  prev?.addEventListener('click', () => {
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });

  next?.addEventListener('click', () => {
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', () => window.requestAnimationFrame(updateArrows), { passive: true });
  window.addEventListener('resize', updateArrows, { passive: true });
  updateArrows();
})();
